export default class DismissCookie {
    constructor( id = '' ) {
        
        this.id = id
        this.cookieName = `cu-alert-bar-gate-dismissed${ this.id && `-${this.id}` }`;
    
        this.cookie = {
            url: this.getDomain(),
            expirationDate: '', //'' for current session expiry
            name: this.cookieName,
            value: true,
        };
    }
    
    getDomain() {
        return window.location.hostname;
    }

    getExpiration(numDays) {
        // Get a date object for the current time
        let d = new Date();

        // Set it to the desired amount of days in future
        d.setDate(d.getDate() + numDays);

        // Zero the hours
        d.setHours(0, 0, 0);

        // Zero the milliseconds
        d.setMilliseconds(0);

        // Get the time value in milliseconds and convert to seconds
        return this.generateCookieDate(d);
    }

    setCookie() {
        let cookieString = `${this.cookie.name}=${this.cookie.value};expires=${this.cookie.expirationDate};domain=${this.cookie.url};path=/;`;

        document.cookie = cookieString;
    }

    /*———— -utilites- ————*/

    generateCookieDate(d) {
        let d2 = (n) => {
            return n < 10 ? '0' + n : n;
        };
        let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        let months = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ];

        return (
            '' +
            days[d.getUTCDay()] +
            ', ' +
            d2(d.getUTCDate()) +
            '-' +
            months[d.getUTCMonth()] +
            '-' +
            d.getUTCFullYear() +
            ' ' +
            d2(d.getUTCHours()) +
            ':' +
            d2(d.getUTCMinutes()) +
            ':' +
            d2(d.getUTCSeconds()) +
            ' GMT'
        );
    }
}
